import OnScreen from 'onscreen';

export default {
  init() {
    const os = new OnScreen();
    // JavaScript to be fired on all pages
    $('.header__language__switcher__box').on('click', function () {
      $('.header__language__switcher').slideToggle();
      $('.header__language__current').toggleClass('header__language__current--active');
    });

    $('input[type=file]').change(function (e) {
      console.log('change');
      var fileName = e.target.files[0].name
      console.log(fileName);
      var parent = $(this).parents('.file-prevent-overflow');
      if (parent.find('file-name').length != 0) {
        parent.find('file-name').html(fileName);
      } else {
        parent.append('<span class="file-name">' + fileName + '</span>');
      }
    });

    $('.header__menu__mobile__outer').on('click', function () {
      $('.header__menu__mobile').toggleClass('header__menu__mobile--active');
      $('.header__menu__wrapper').toggleClass('header__menu__wrapper--active');
      $('body').toggleClass('disabled');
      $('.header__menu__mobile__outer span').toggle();
    });

    if (($.screenwidth() < 990)) {
      $('.footer__links__item h3').on('click', function () {
        $(this).next().slideToggle();
        $(this).parents('.footer__links__item').toggleClass('footer__links__item--active');
      });
    }

    os.on('enter', '.add_fadeInRight ', (element) => {
      if (element.classList.contains('add_fadeInRight') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
        element.classList.remove('add_fadeInRight');
        element.className += ' fadeInRight  show';
      }
    });
    os.on('enter', '.add_fadeInMobile ', (element) => {
      if (element.classList.contains('add_fadeInMobile') && ($.screenwidth() < 990)) {
        element.classList.remove('add_fadeInMobile');
        element.className += ' fadeIn  show';
      }
    });

    $('a.button--smooth_scroll').click(function (e) {
      var href = $(this).attr('href');
      var currentPath = window.location.pathname;
      if (href.indexOf('#') >= 0) {
        var parts = href.split('#');
        if ($('#' + parts[1]).length > 0) {
          e.preventDefault();
          $('html, body').animate({
            scrollTop: $('#' + parts[1]).offset().top - 100,
          }, 500);
          if (parts[1] == 'partners' || parts[1] == 'contact') {
            var finalUrl = currentPath + '#' + parts[1];
            history.pushState(null, null, finalUrl);
          } else {
            history.pushState(null, null, href);
          }
        }
      }
    });
  },
  finalize() {
    const os = new OnScreen();
    // JavaScript to be fired on the home page, after the init JS
    os.on('enter', '.js-lines', (element) => {
      if (element.classList.contains('js-lines-init') && ($.screenwidth() >= 990)) {
        element.classList.remove('js-lines-init');
        element.className += ' js-lines-active';
      }
    });
    os.on('leave', '.js-lines', (element) => {
      if (element.classList.contains('js-lines-active') && ($.screenwidth() >= 990)) {
        element.classList.remove('js-lines-active');
        element.className += ' js-lines-init';
      }
    });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js